import { forwardRef } from 'react';
export const AppliedJobsNotFoundIll = forwardRef(({ ...props }, ref) => {
  return (
    <>
      <svg
        width="266"
        height="230"
        viewBox="0 0 266 230"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_3185_48915)">
          <path
            d="M282.625 194.394H-14.25V194.542H282.625V194.394Z"
            fill="#B3B3B3"
          />
          <path
            d="M252.878 203.947H233.213V204.096H252.878V203.947Z"
            fill="#B3B3B3"
          />
          <path
            d="M182.412 205.562H177.252V205.711H182.412V205.562Z"
            fill="#B3B3B3"
          />
          <path
            d="M232.619 198.437H221.225V198.586H232.619V198.437Z"
            fill="#B3B3B3"
          />
          <path
            d="M42.5421 199.435H16.8981V199.583H42.5421V199.435Z"
            fill="#B3B3B3"
          />
          <path
            d="M51.591 199.435H47.8325V199.583H51.591V199.435Z"
            fill="#B3B3B3"
          />
          <path
            d="M119.433 201.94H63.8103V202.089H119.433V201.94Z"
            fill="#B3B3B3"
          />
          <path
            d="M126.469 167.912H11.8215C10.9234 167.911 10.0626 167.553 9.42803 166.917C8.79351 166.282 8.43713 165.42 8.43713 164.522V3.36062C8.44495 2.46764 8.80478 1.6138 9.43846 0.984567C10.0721 0.355335 10.9285 0.00152973 11.8215 0H126.469C127.368 0 128.23 0.357193 128.866 0.993C129.502 1.62881 129.859 2.49115 129.859 3.39031V164.522C129.859 165.421 129.502 166.284 128.866 166.92C128.23 167.555 127.368 167.912 126.469 167.912ZM11.8215 0.11875C10.9627 0.120323 10.1397 0.46257 9.533 1.07037C8.92631 1.67817 8.58557 2.50185 8.58557 3.36062V164.522C8.58557 165.381 8.92631 166.205 9.533 166.812C10.1397 167.42 10.9627 167.762 11.8215 167.764H126.469C127.328 167.762 128.152 167.42 128.759 166.813C129.367 166.205 129.709 165.382 129.711 164.522V3.36062C129.709 2.50131 129.367 1.67764 128.759 1.07001C128.152 0.462377 127.328 0.12032 126.469 0.11875H11.8215Z"
            fill="#B3B3B3"
          />
          <path
            d="M254.903 167.912H140.25C139.351 167.911 138.49 167.553 137.854 166.918C137.219 166.282 136.861 165.421 136.859 164.522V3.36062C136.869 2.4671 137.23 1.61326 137.865 0.984196C138.499 0.355127 139.356 0.00151305 140.25 0H254.903C255.795 0.00309017 256.65 0.357585 257.282 0.986651C257.914 1.61572 258.273 2.46867 258.281 3.36062V164.522C258.281 165.419 257.926 166.28 257.292 166.915C256.659 167.551 255.8 167.909 254.903 167.912ZM140.25 0.11875C139.39 0.12032 138.567 0.462377 137.959 1.07001C137.351 1.67764 137.009 2.50131 137.008 3.36062V164.522C137.009 165.382 137.351 166.205 137.959 166.813C138.567 167.42 139.39 167.762 140.25 167.764H254.903C255.762 167.762 256.586 167.42 257.193 166.813C257.801 166.205 258.143 165.382 258.145 164.522V3.36062C258.143 2.50131 257.801 1.67764 257.193 1.07001C256.586 0.462377 255.762 0.12032 254.903 0.11875H140.25Z"
            fill="#B3B3B3"
          />
          <path
            d="M259.593 62.7594H154.921V166.903H259.593V62.7594Z"
            fill="#F0F0F0"
          />
          <path
            d="M255.894 67.5925H158.62V95.9382H255.894V67.5925Z"
            fill="#E0E0E0"
          />
          <path
            d="M164.148 72.1822H158.62V95.9381H164.148V72.1822Z"
            fill="#B3B3B3"
          />
          <path
            d="M190.867 72.1822H185.339V95.9381H190.867V72.1822Z"
            fill="#B3B3B3"
          />
          <path
            d="M221.199 71.5845L215.751 72.5234L219.787 95.9341L225.234 94.9951L221.199 71.5845Z"
            fill="#B3B3B3"
          />
          <path
            d="M170.994 75.3113H165.466V95.9382H170.994V75.3113Z"
            fill="#B3B3B3"
          />
          <path
            d="M183.694 75.3113H178.167V95.9382H183.694V75.3113Z"
            fill="#B3B3B3"
          />
          <path
            d="M215.757 75.3113H210.229V95.9382H215.757V75.3113Z"
            fill="#B3B3B3"
          />
          <path
            d="M198.128 74.5885L192.732 75.7877L197.207 95.9233L202.603 94.724L198.128 74.5885Z"
            fill="#B3B3B3"
          />
          <path
            d="M175.768 71.0006H173.007V95.9322H175.768V71.0006Z"
            fill="#B3B3B3"
          />
          <path
            d="M208.638 71.0006H205.877V95.9322H208.638V71.0006Z"
            fill="#B3B3B3"
          />
          <path
            d="M158.62 128.767H255.894V100.421L158.62 100.421V128.767Z"
            fill="#E0E0E0"
          />
          <path
            d="M250.366 128.767H255.894V105.011H250.366V128.767Z"
            fill="#B3B3B3"
          />
          <path
            d="M223.648 128.767H229.176V105.011H223.648V128.767Z"
            fill="#B3B3B3"
          />
          <path
            d="M189.285 127.821L194.732 128.76L198.768 105.349L193.32 104.41L189.285 127.821Z"
            fill="#B3B3B3"
          />
          <path
            d="M243.521 128.767H249.048V108.14H243.521V128.767Z"
            fill="#B3B3B3"
          />
          <path
            d="M230.82 128.767H236.348V108.14H230.82V128.767Z"
            fill="#B3B3B3"
          />
          <path
            d="M198.758 128.767H204.286V108.14H198.758V128.767Z"
            fill="#B3B3B3"
          />
          <path
            d="M211.462 126.307L216.879 127.523L221.417 107.309L216 106.092L211.462 126.307Z"
            fill="#B3B3B3"
          />
          <path
            d="M238.747 128.767H241.508V103.835H238.747V128.767Z"
            fill="#B3B3B3"
          />
          <path
            d="M205.877 128.767H208.638V103.835H205.877V128.767Z"
            fill="#B3B3B3"
          />
          <path
            d="M164.148 105.011H158.62V128.767H164.148V105.011Z"
            fill="#B3B3B3"
          />
          <path
            d="M170.994 108.14H165.466V128.767H170.994V108.14Z"
            fill="#B3B3B3"
          />
          <path
            d="M183.694 108.14H178.167V128.767H183.694V108.14Z"
            fill="#B3B3B3"
          />
          <path
            d="M175.768 103.829H173.007V128.761H175.768V103.829Z"
            fill="#B3B3B3"
          />
          <path
            d="M255.894 133.255H158.62V161.601H255.894V133.255Z"
            fill="#E0E0E0"
          />
          <path
            d="M219.978 137.839H214.451V161.595H219.978V137.839Z"
            fill="#B3B3B3"
          />
          <path
            d="M250.312 137.244L244.864 138.183L248.9 161.594L254.347 160.655L250.312 137.244Z"
            fill="#B3B3B3"
          />
          <path
            d="M200.106 140.974H194.578V161.601H200.106V140.974Z"
            fill="#B3B3B3"
          />
          <path
            d="M212.812 140.974H207.284V161.601H212.812V140.974Z"
            fill="#B3B3B3"
          />
          <path
            d="M244.868 140.974H239.341V161.601H244.868V140.974Z"
            fill="#B3B3B3"
          />
          <path
            d="M227.242 140.251L221.846 141.45L226.321 161.585L231.717 160.386L227.242 140.251Z"
            fill="#B3B3B3"
          />
          <path
            d="M204.879 136.663H202.118V161.595H204.879V136.663Z"
            fill="#B3B3B3"
          />
          <path
            d="M237.749 136.663H234.989V161.595H237.749V136.663Z"
            fill="#B3B3B3"
          />
          <path
            d="M186.749 137.247L181.301 138.186L185.336 161.597L190.784 160.658L186.749 137.247Z"
            fill="#B3B3B3"
          />
          <path
            d="M181.296 140.974H175.768V161.601H181.296V140.974Z"
            fill="#B3B3B3"
          />
          <path
            d="M163.675 140.255L158.279 141.454L162.754 161.589L168.15 160.39L163.675 140.255Z"
            fill="#B3B3B3"
          />
          <path
            d="M174.177 136.663H171.416V161.595H174.177V136.663Z"
            fill="#B3B3B3"
          />
          <path
            d="M8.00371 166.903H112.676L112.676 62.7594L8.00371 62.7594L8.00371 166.903Z"
            fill="#F0F0F0"
          />
          <path
            d="M11.7028 95.9322L108.977 95.9322V67.5866L11.7028 67.5866V95.9322Z"
            fill="#E0E0E0"
          />
          <path
            d="M103.449 95.9322H108.977V72.1763H103.449V95.9322Z"
            fill="#B3B3B3"
          />
          <path
            d="M76.7304 95.9322H82.2582V72.1763H76.7304V95.9322Z"
            fill="#B3B3B3"
          />
          <path
            d="M42.3686 94.9911L47.816 95.9301L51.8514 72.5194L46.4039 71.5804L42.3686 94.9911Z"
            fill="#B3B3B3"
          />
          <path
            d="M96.6032 95.9322H102.131V75.3053H96.6032V95.9322Z"
            fill="#B3B3B3"
          />
          <path
            d="M83.8969 95.9322H89.4247V75.3053H83.8969V95.9322Z"
            fill="#B3B3B3"
          />
          <path
            d="M51.8404 95.9322H57.3682V75.3053H51.8404V95.9322Z"
            fill="#B3B3B3"
          />
          <path
            d="M65.0025 94.7366L70.3987 95.9359L74.8737 75.8003L69.4775 74.601L65.0025 94.7366Z"
            fill="#B3B3B3"
          />
          <path
            d="M91.8294 95.9322H94.5903V71.0006H91.8294V95.9322Z"
            fill="#B3B3B3"
          />
          <path
            d="M58.9594 95.9322H61.7203V71.0006H58.9594V95.9322Z"
            fill="#B3B3B3"
          />
          <path
            d="M108.977 100.421H11.7028V128.767H108.977V100.421Z"
            fill="#E0E0E0"
          />
          <path
            d="M17.2306 105.011H11.7028V128.767H17.2306V105.011Z"
            fill="#B3B3B3"
          />
          <path
            d="M43.9493 105.011H38.4215V128.767H43.9493V105.011Z"
            fill="#B3B3B3"
          />
          <path
            d="M74.7149 105.022L69.2423 105.962L73.2808 129.48L78.7534 128.541L74.7149 105.022Z"
            fill="#B3B3B3"
          />
          <path
            d="M24.0765 108.14H18.5487V128.767H24.0765V108.14Z"
            fill="#B3B3B3"
          />
          <path
            d="M36.7768 108.14H31.249V128.767H36.7768V108.14Z"
            fill="#B3B3B3"
          />
          <path
            d="M68.8393 108.14H63.3115V128.767H68.8393V108.14Z"
            fill="#B3B3B3"
          />
          <path
            d="M51.2106 107.432L45.8145 108.631L50.2895 128.767L55.6856 127.567L51.2106 107.432Z"
            fill="#B3B3B3"
          />
          <path
            d="M28.8503 103.829H26.0894V128.761H28.8503V103.829Z"
            fill="#B3B3B3"
          />
          <path
            d="M61.7203 103.829H58.9594V128.761H61.7203V103.829Z"
            fill="#B3B3B3"
          />
          <path
            d="M103.449 128.767H108.977V105.011H103.449V128.767Z"
            fill="#B3B3B3"
          />
          <path
            d="M96.6032 128.767H102.131V108.14H96.6032V128.767Z"
            fill="#B3B3B3"
          />
          <path
            d="M83.8969 128.767H89.4247V108.14H83.8969V128.767Z"
            fill="#B3B3B3"
          />
          <path
            d="M91.8294 128.767H94.5903V103.835H91.8294V128.767Z"
            fill="#B3B3B3"
          />
          <path
            d="M11.7028 161.595H108.977V133.249H11.7028V161.595Z"
            fill="#E0E0E0"
          />
          <path
            d="M47.6188 161.601H53.1466V137.845H47.6188V161.601Z"
            fill="#B3B3B3"
          />
          <path
            d="M13.2528 160.657L18.7003 161.596L22.7356 138.186L17.2882 137.247L13.2528 160.657Z"
            fill="#B3B3B3"
          />
          <path
            d="M67.4856 161.595H73.0134V140.968H67.4856V161.595Z"
            fill="#B3B3B3"
          />
          <path
            d="M54.7853 161.595H60.3131V140.968H54.7853V161.595Z"
            fill="#B3B3B3"
          />
          <path
            d="M22.7288 161.595H28.2566L28.2566 140.968H22.7288L22.7288 161.595Z"
            fill="#B3B3B3"
          />
          <path
            d="M35.8939 160.4L41.29 161.599L45.7651 141.464L40.3689 140.264L35.8939 160.4Z"
            fill="#B3B3B3"
          />
          <path
            d="M62.7178 161.595H65.4788V136.663H62.7178V161.595Z"
            fill="#B3B3B3"
          />
          <path
            d="M29.8478 161.595H32.6088V136.663H29.8478L29.8478 161.595Z"
            fill="#B3B3B3"
          />
          <path
            d="M76.8233 160.653L82.2708 161.592L86.3061 138.181L80.8586 137.242L76.8233 160.653Z"
            fill="#B3B3B3"
          />
          <path
            d="M86.3015 161.595H91.8293V140.968H86.3015V161.595Z"
            fill="#B3B3B3"
          />
          <path
            d="M99.4668 160.395L104.863 161.594L109.338 141.458L103.942 140.259L99.4668 160.395Z"
            fill="#B3B3B3"
          />
          <path
            d="M93.4206 161.595H96.1815V136.663H93.4206V161.595Z"
            fill="#B3B3B3"
          />
          <path
            d="M135.399 38.1544C142.233 38.1544 147.773 32.6144 147.773 25.7806C147.773 18.9468 142.233 13.4069 135.399 13.4069C128.565 13.4069 123.025 18.9468 123.025 25.7806C123.025 32.6144 128.565 38.1544 135.399 38.1544Z"
            fill="#E0E0E0"
          />
          <path
            d="M135.399 36.1831C141.144 36.1831 145.801 31.5258 145.801 25.7806C145.801 20.0355 141.144 15.3781 135.399 15.3781C129.654 15.3781 124.996 20.0355 124.996 25.7806C124.996 31.5258 129.654 36.1831 135.399 36.1831Z"
            fill="#B3B3B3"
          />
          <path
            d="M135.375 26.3744C135.286 26.3672 135.2 26.3399 135.122 26.2947C135.045 26.2495 134.979 26.1874 134.93 26.1132L130.625 19.7303C130.581 19.6656 130.551 19.5929 130.535 19.5164C130.52 19.4399 130.519 19.3611 130.534 19.2845C130.549 19.2078 130.579 19.1349 130.622 19.0698C130.665 19.0047 130.721 18.9487 130.785 18.905C130.85 18.8614 130.923 18.8309 130.999 18.8153C131.076 18.7997 131.155 18.7994 131.231 18.8143C131.308 18.8291 131.381 18.859 131.446 18.9021C131.511 18.9451 131.567 19.0006 131.611 19.0653L135.494 24.8247L138.201 21.856C138.252 21.7927 138.316 21.7407 138.387 21.7029C138.459 21.6652 138.538 21.6425 138.619 21.6365C138.7 21.6304 138.781 21.641 138.858 21.6676C138.935 21.6943 139.005 21.7363 139.065 21.7913C139.125 21.8462 139.173 21.9128 139.206 21.9869C139.239 22.0611 139.256 22.1413 139.257 22.2225C139.258 22.3037 139.242 22.3841 139.211 22.459C139.179 22.5338 139.133 22.6014 139.074 22.6575L135.856 26.1725C135.796 26.2406 135.722 26.2941 135.639 26.3291C135.555 26.3641 135.465 26.3796 135.375 26.3744Z"
            fill="#E0E0E0"
          />
          <path
            d="M134.187 221.207C197.768 221.207 249.31 218.198 249.31 214.486C249.31 210.774 197.768 207.765 134.187 207.765C70.6073 207.765 19.0653 210.774 19.0653 214.486C19.0653 218.198 70.6073 221.207 134.187 221.207Z"
            fill="#F5F5F5"
          />
          <path
            d="M166.25 131.302L162.866 161.512H185.487L188.159 131.302H166.25Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.3"
            d="M166.25 131.302L162.866 161.512H182.857L185.529 131.302H166.25Z"
            fill="white"
          />
          <path
            opacity="0.1"
            d="M185.529 131.302L182.857 161.512H185.487L188.159 131.302H185.529Z"
            fill="white"
          />
          <path
            d="M195.73 137.429H160.366C160.104 137.43 159.845 137.377 159.604 137.274C159.363 137.171 159.146 137.021 158.965 136.831C158.784 136.642 158.643 136.418 158.551 136.173C158.46 135.928 158.418 135.666 158.43 135.405L160.568 90.8141C160.591 90.3179 160.804 89.8496 161.164 89.5068C161.523 89.164 162.001 88.9729 162.498 88.9735H198.051L195.73 137.429Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.2"
            d="M195.112 88.9734L192.791 137.429H195.73L198.051 88.9734H195.112Z"
            fill="white"
          />
          <path
            opacity="0.1"
            d="M191.87 91.0456L189.763 135.149C189.749 135.443 189.795 135.737 189.898 136.013C190.001 136.289 190.159 136.541 190.362 136.754C190.565 136.967 190.809 137.137 191.08 137.253C191.35 137.369 191.641 137.429 191.936 137.429H192.791L195.112 88.9734H194.049C193.49 88.9742 192.952 89.1896 192.547 89.5751C192.141 89.9606 191.899 90.4869 191.87 91.0456Z"
            fill="#878787"
          />
          <path
            d="M159.861 162.593L160.14 171.837L161.399 213.655H165.555L166.808 171.837L167.087 162.593H159.861Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.4"
            d="M159.861 162.593L160.14 171.837L161.399 213.655H165.555L166.808 171.837L167.087 162.593H159.861Z"
            fill="white"
          />
          <path
            opacity="0.2"
            d="M159.861 162.593L160.14 172.093H166.808L167.087 162.593H159.861Z"
            fill="#878787"
          />
          <path
            d="M137.287 213.507L141.128 163.246H147.404L142.031 213.507H137.287Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.5"
            d="M142.043 213.507H137.293L140.778 167.758L141.128 163.186H147.404L146.918 167.758L142.043 213.507Z"
            fill="white"
          />
          <path
            opacity="0.2"
            d="M147.404 163.186L146.918 167.936H140.778L141.129 163.186H147.404Z"
            fill="#878787"
          />
          <path
            d="M184.923 213.507L179.544 163.246H185.82L189.662 213.507H184.923Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.5"
            d="M184.912 213.507L180.031 167.758L179.55 163.186H185.826L186.17 167.758L189.656 213.507H184.912Z"
            fill="white"
          />
          <path
            opacity="0.2"
            d="M179.55 163.186L180.031 167.936H186.17L185.826 163.186H179.55Z"
            fill="#878787"
          />
          <path
            d="M189.198 164.979H137.78V161.007C137.78 160.22 138.093 159.465 138.649 158.908C139.206 158.351 139.961 158.038 140.748 158.038H186.23C187.017 158.038 187.772 158.351 188.329 158.908C188.886 159.465 189.198 160.22 189.198 161.007V164.979Z"
            fill="#D0D0D0"
          />
          <path
            d="M136.491 164.985H190.451C191.11 164.985 191.645 164.451 191.645 163.792V162.711C191.645 162.052 191.11 161.518 190.451 161.518H136.491C135.832 161.518 135.298 162.052 135.298 162.711V163.792C135.298 164.451 135.832 164.985 136.491 164.985Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.6"
            d="M136.491 164.985H190.451C191.11 164.985 191.645 164.451 191.645 163.792V162.711C191.645 162.052 191.11 161.518 190.451 161.518H136.491C135.832 161.518 135.298 162.052 135.298 162.711V163.792C135.298 164.451 135.832 164.985 136.491 164.985Z"
            fill="white"
          />
          <path
            opacity="0.1"
            d="M180.933 158.044H172.235L155.046 157.344L155.319 158.484L142.019 158.591L141.336 158.781L142.019 164.979H157.415L156.305 159.392C162.266 159.357 177.413 160.734 180.933 158.044Z"
            fill="#878787"
          />
          <path
            d="M145.837 110.265C145.837 110.265 128.98 113.828 128.024 113.982C127.068 114.137 122.562 112.795 121.695 112.919C120.828 113.044 119.409 117.111 119.32 118.02C119.231 118.928 126.392 119.599 127.039 119.35C127.735 118.977 128.393 118.537 129.004 118.038L146.633 116.179L145.837 110.265Z"
            fill="#D1D1D1"
          />
          <path
            d="M178.748 87.2575L169.385 87.7266L167.277 90.2025L179.2 89.9413L178.748 87.2575Z"
            fill="#D0D0D0"
          />
          <path
            d="M160.574 102.481C160.574 102.481 160.408 102.933 160.105 103.669C159.802 104.405 159.339 105.527 158.775 106.75C157.409 109.719 155.426 113.495 153.354 115.532C152.833 116.08 152.207 116.516 151.513 116.814C149.304 117.663 143.872 118.061 138.926 118.002C133.98 117.943 129.645 118.406 129.645 118.406V113.157L145.908 109.381C145.908 109.381 154.482 94.0203 159.564 91.7285L160.574 102.481Z"
            fill="#AAAAAA"
          />
          <path
            opacity="0.2"
            d="M160.105 103.675C159.796 104.447 159.339 105.533 158.775 106.756C157.409 109.725 155.426 113.501 153.354 115.538C151.246 107.772 159.042 100.379 159.042 100.379L160.105 103.675Z"
            fill="#878787"
          />
          <path
            d="M158.003 210.116L153.277 209.463L152.618 198.224L157.344 198.877L158.003 210.116Z"
            fill="#D1D1D1"
          />
          <path
            opacity="0.2"
            d="M157.344 198.877L152.618 198.229L152.998 204.654L157.712 205.069L157.344 198.877Z"
            fill="#878787"
          />
          <path
            d="M157.813 144.02L158.971 136.788L185.488 135.203C185.488 135.203 188.308 150.248 186.141 154.256C182.269 161.411 161.429 157.819 155.331 158.502C158.977 173.411 158.62 202.546 158.62 202.546L149.91 203.211C149.91 203.211 143.207 171.819 141.853 156.898C140.938 146.834 149.275 147.084 157.813 144.02Z"
            fill="#D0D0D0"
          />
          <path
            d="M147.096 205.918L142.334 206.263L139.347 195.403L144.103 195.059L147.096 205.918Z"
            fill="#D1D1D1"
          />
          <path
            d="M141.687 206.429H141.609C141.609 206.358 141.372 205.028 140.79 204.707C140.716 204.672 140.635 204.654 140.553 204.654C140.47 204.654 140.389 204.672 140.315 204.707C140.224 204.735 140.146 204.794 140.093 204.873C140.04 204.951 140.016 205.046 140.024 205.141C140.141 205.535 140.39 205.877 140.731 206.108C140.295 205.96 139.821 205.973 139.395 206.144C139.339 206.187 139.295 206.243 139.267 206.308C139.239 206.372 139.228 206.442 139.234 206.512C139.225 206.625 139.248 206.738 139.301 206.837C139.353 206.937 139.433 207.02 139.531 207.076C139.829 207.195 140.16 207.195 140.458 207.076C140.871 206.956 141.27 206.789 141.645 206.578C141.651 206.582 141.658 206.584 141.666 206.584C141.673 206.584 141.681 206.582 141.687 206.578C141.687 206.578 141.687 206.578 141.687 206.542C141.696 206.536 141.705 206.528 141.71 206.518C141.716 206.508 141.719 206.497 141.719 206.486C141.719 206.474 141.716 206.463 141.71 206.453C141.705 206.443 141.696 206.435 141.687 206.429ZM140.256 205.099C140.256 205.034 140.256 204.951 140.416 204.885H140.469C140.512 204.874 140.557 204.871 140.601 204.877C140.645 204.883 140.687 204.898 140.725 204.921C141.069 205.105 141.318 205.824 141.419 206.263L141.313 206.233C140.843 205.954 140.297 205.438 140.256 205.099ZM139.632 206.839C139.574 206.8 139.526 206.747 139.494 206.685C139.461 206.622 139.446 206.553 139.448 206.483C139.445 206.447 139.45 206.412 139.465 206.379C139.48 206.347 139.503 206.319 139.531 206.298C139.798 206.097 140.671 206.269 141.313 206.459C140.523 206.851 139.911 206.993 139.632 206.839Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.2"
            d="M144.103 195.059L139.347 195.409L141.057 201.62L145.754 201.044L144.103 195.059Z"
            fill="#878787"
          />
          <path
            d="M137.75 200.854L146.134 198.39C146.134 198.39 141.129 170.139 136.04 160.342C136.42 160.218 136.925 160.057 137.548 159.873C138.67 159.535 140.161 159.113 141.912 158.626C154.096 155.248 178.79 148.913 178.79 148.913L167.509 138.385C167.509 138.385 122.574 145.237 121.642 157.077C121.196 162.771 137.75 200.854 137.75 200.854Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.2"
            d="M137.548 159.873C138.67 159.535 140.268 159.083 142.019 158.597C141.669 155.723 141.556 152.457 142.939 150.777C145.688 147.428 152.76 145.463 156.786 144.75C160.152 144.157 171.463 142.969 171.463 142.969C171.463 142.969 156.786 141.562 141.776 145.938C134.366 148.111 135.808 155.361 137.548 159.873Z"
            fill="#878787"
          />
          <path
            d="M186.96 142.761C188.741 141.402 187.025 128.755 187.934 116.31C189.317 97.3751 187.934 91.2891 186.539 90.7013C183.965 90.2515 181.361 89.9935 178.748 89.9294C174.923 89.7878 171.093 89.8691 167.277 90.1729C164.668 90.4978 162.087 91.0238 159.559 91.7463C159.559 91.7463 153.312 111.631 157.302 140.285L186.96 142.761Z"
            fill="#AAAAAA"
          />
          <path
            opacity="0.1"
            d="M186.96 142.761C188.741 141.402 187.025 128.755 187.934 116.31C189.317 97.3751 187.934 91.2891 186.539 90.7013C183.965 90.2515 181.361 89.9935 178.748 89.9294C174.923 89.7878 171.093 89.8691 167.277 90.1729C164.668 90.4978 162.087 91.0238 159.559 91.7463C159.559 91.7463 153.312 111.631 157.302 140.285L186.96 142.761Z"
            fill="white"
          />
          <path
            d="M177.335 77.0688C176.688 80.7738 176.112 87.5485 178.748 89.9591C177.68 91.1048 176.396 92.0277 174.969 92.6748C173.542 93.3219 172.002 93.6803 170.436 93.7294C165.686 93.9372 167.283 90.2025 167.283 90.2025C171.38 89.1338 171.208 86.0819 170.43 83.226L177.335 77.0688Z"
            fill="#D1D1D1"
          />
          <path
            opacity="0.2"
            d="M174.521 79.5626L170.406 83.226C170.595 83.8906 170.728 84.5698 170.804 85.2566C172.372 84.9954 175.744 81.6466 175.881 79.996C175.982 79.331 174.681 80.2335 174.521 79.5626Z"
            fill="#878787"
          />
          <path
            d="M168.358 67.4797C170.406 68.8691 169.474 71.2263 164.843 74.9075C162.961 72.4672 162.646 67.735 164.142 66.5416C165.639 65.3482 166.571 66.2803 168.358 67.4797Z"
            fill="#AAAAAA"
          />
          <path
            d="M177.163 71.2975C176.937 76.3028 177.062 79.2359 174.586 81.8484C170.852 85.7672 164.647 83.5881 163.364 78.6184C162.224 74.1534 162.771 66.7434 167.633 64.6475C168.702 64.1867 169.871 64.0064 171.029 64.1239C172.187 64.2413 173.296 64.6526 174.25 65.3186C175.205 65.9847 175.973 66.8835 176.483 67.9298C176.993 68.9762 177.227 70.1353 177.163 71.2975Z"
            fill="#D1D1D1"
          />
          <path
            d="M169.723 72.7938C169.723 73.2035 169.516 73.536 169.248 73.536C168.981 73.536 168.768 73.2213 168.762 72.8116C168.756 72.4019 168.963 72.0753 169.225 72.0635C169.486 72.0516 169.688 72.396 169.723 72.7938Z"
            fill="#AAAAAA"
          />
          <path
            d="M165.098 72.8769C165.098 73.2866 164.89 73.6191 164.629 73.625C164.368 73.631 164.136 73.3044 164.13 72.8947C164.124 72.485 164.332 72.1525 164.599 72.1525C164.867 72.1525 165.092 72.4732 165.098 72.8769Z"
            fill="#AAAAAA"
          />
          <path
            d="M166.606 73.0313C166.142 74.2834 165.509 75.466 164.724 76.5463C165.007 76.7381 165.328 76.8666 165.665 76.9229C166.002 76.9793 166.348 76.9622 166.678 76.8729L166.606 73.0313Z"
            fill="#C1C1C1"
          />
          <path
            d="M170.958 71.3153C171.012 71.3215 171.067 71.3089 171.113 71.2797C171.163 71.24 171.195 71.1823 171.203 71.119C171.21 71.0557 171.193 70.9919 171.154 70.9413C170.927 70.6381 170.631 70.3937 170.29 70.2285C169.949 70.0632 169.574 69.9819 169.195 69.9913C169.165 69.992 169.135 69.9988 169.108 70.0112C169.08 70.0237 169.055 70.0415 169.035 70.0636C169.014 70.0858 168.999 70.1118 168.988 70.1401C168.978 70.1685 168.974 70.1986 168.975 70.2288C168.984 70.2912 169.016 70.3481 169.064 70.3887C169.112 70.4292 169.174 70.4505 169.237 70.4484C169.535 70.4449 169.831 70.5125 170.098 70.6457C170.365 70.7789 170.597 70.9738 170.774 71.2144C170.796 71.2439 170.823 71.2683 170.855 71.2857C170.887 71.3032 170.922 71.3133 170.958 71.3153Z"
            fill="#AAAAAA"
          />
          <path
            d="M162.967 71.3569C163.012 71.3548 163.056 71.3404 163.093 71.3153C163.131 71.2902 163.161 71.2553 163.18 71.2144C163.299 70.9401 163.481 70.6976 163.711 70.5068C163.941 70.3159 164.213 70.182 164.504 70.116C164.567 70.1057 164.624 70.0717 164.663 70.0209C164.701 69.97 164.719 69.9063 164.712 69.8429C164.702 69.781 164.669 69.7252 164.619 69.6867C164.57 69.6482 164.508 69.6297 164.445 69.6351C164.072 69.7124 163.723 69.8785 163.427 70.1193C163.131 70.3601 162.898 70.6685 162.747 71.0185C162.72 71.0752 162.717 71.1401 162.739 71.199C162.76 71.258 162.803 71.3062 162.86 71.3332C162.893 71.3481 162.93 71.3561 162.967 71.3569Z"
            fill="#AAAAAA"
          />
          <path
            d="M175.097 66.9038C172.769 67.741 173.102 70.2585 176.688 74.961C179.111 73.055 180.577 68.5307 179.413 67.0166C178.25 65.5025 177.122 66.1735 175.097 66.9038Z"
            fill="#AAAAAA"
          />
          <path
            d="M179.609 75.2579C179.448 75.8608 179.169 76.4259 178.789 76.9211C178.409 77.4162 177.935 77.8316 177.395 78.1435C175.94 78.9629 174.818 77.7576 174.889 76.1782C174.948 74.7591 175.786 72.6157 177.401 72.4435C179.016 72.2713 180.007 73.7616 179.609 75.2579Z"
            fill="#D1D1D1"
          />
          <path
            d="M170.406 77.7159C170.406 77.7159 169.539 79.3547 167.117 79.2775"
            stroke="#AAAAAA"
            stroke-width="0.526291"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M170.02 66.1082C170.02 66.1082 170.763 71.1194 175.59 71.4519C180.417 71.7844 180.263 68.875 180.263 68.875C180.619 68.1277 180.804 67.3102 180.804 66.4822C180.804 65.6542 180.619 64.8367 180.263 64.0894C179.152 61.8925 173.238 62.5753 170.43 62.041C158.49 58.8763 158.555 62.4863 160.966 67.3847C160.966 67.3847 160.182 69.255 163.079 70.6622C163.079 70.6563 163.632 65.5797 170.02 66.1082Z"
            fill="#AAAAAA"
          />
          <path
            d="M161.809 113.466C161.809 113.466 144.59 113.074 143.616 112.973C142.642 112.872 138.569 110.598 137.679 110.479C136.788 110.36 134.484 114.042 134.199 114.897C133.914 115.752 140.731 118.061 141.384 117.966C142.147 117.763 142.888 117.487 143.598 117.141L161.179 119.403L161.809 113.466Z"
            fill="#D1D1D1"
          />
          <path
            opacity="0.2"
            d="M188.45 106.566C185.891 110.723 182.311 115.146 178.743 114.938C175.008 114.718 178.743 107.095 182.786 100.457C182.935 100.76 183.068 101.071 183.184 101.389C184.092 103.93 186.865 100.795 188.278 96.71C188.519 99.9897 188.576 103.28 188.45 106.566Z"
            fill="#878787"
          />
          <path
            d="M141.865 205.782L147.019 204.345C147.061 204.33 147.105 204.324 147.15 204.327C147.194 204.33 147.238 204.341 147.278 204.361C147.317 204.381 147.353 204.409 147.382 204.443C147.411 204.477 147.433 204.516 147.446 204.559L148.835 208.573C148.865 208.68 148.873 208.792 148.859 208.902C148.846 209.013 148.81 209.119 148.755 209.216C148.7 209.312 148.626 209.397 148.538 209.465C148.45 209.533 148.349 209.583 148.242 209.612C146.46 210.081 145.546 210.205 143.272 210.835C141.877 211.221 139.163 212.111 137.174 212.337C135.185 212.563 135.013 210.591 135.838 210.318C137.78 209.671 140.113 207.64 141.123 206.263C141.309 206.023 141.57 205.854 141.865 205.782Z"
            fill="#AAAAAA"
          />
          <path
            d="M152.802 209.475C152.802 209.392 152.724 208.044 152.208 207.611C152.054 207.502 151.865 207.457 151.679 207.486C151.583 207.496 151.491 207.537 151.419 207.602C151.346 207.667 151.296 207.753 151.276 207.848C151.292 208.258 151.459 208.647 151.745 208.941C151.346 208.705 150.877 208.618 150.421 208.697C150.355 208.726 150.298 208.773 150.257 208.831C150.215 208.89 150.19 208.958 150.183 209.03C150.155 209.135 150.155 209.246 150.186 209.351C150.216 209.455 150.275 209.55 150.355 209.623C150.626 209.791 150.949 209.855 151.264 209.802C151.685 209.76 152.1 209.677 152.505 209.552H152.594C152.594 209.552 152.594 209.552 152.594 209.517C152.594 209.481 152.713 209.517 152.713 209.469H152.813L152.802 209.475ZM151.489 207.89C151.489 207.824 151.531 207.747 151.691 207.717H151.745C151.789 207.714 151.833 207.72 151.875 207.735C151.917 207.749 151.955 207.771 151.988 207.801C152.272 208.233 152.413 208.744 152.392 209.261L152.291 209.208C151.876 208.877 151.592 208.41 151.489 207.89ZM150.516 209.463C150.465 209.414 150.429 209.352 150.411 209.284C150.394 209.216 150.395 209.145 150.415 209.077C150.417 209.042 150.429 209.008 150.449 208.979C150.469 208.95 150.496 208.926 150.527 208.911C150.83 208.774 151.65 209.119 152.226 209.439C151.406 209.659 150.753 209.671 150.516 209.463Z"
            fill="#D0D0D0"
          />
          <path
            d="M152.92 208.893L158.264 208.561C158.308 208.556 158.353 208.56 158.396 208.572C158.438 208.585 158.478 208.606 158.512 208.634C158.546 208.663 158.575 208.697 158.595 208.737C158.616 208.776 158.628 208.819 158.632 208.863L159.161 213.079C159.174 213.3 159.1 213.517 158.954 213.684C158.809 213.85 158.603 213.953 158.383 213.97C156.512 214.059 155.616 214.005 153.265 214.13C151.822 214.219 148.978 214.528 146.989 214.332C145 214.136 145.237 212.177 146.098 212.082C148.141 211.85 150.848 210.354 152.119 209.214C152.343 209.02 152.625 208.907 152.92 208.893Z"
            fill="#AAAAAA"
          />
          <path
            d="M186.538 90.7013C183.701 92.1055 181.367 94.3538 179.859 97.1376C177.139 101.935 172.419 112.1 170.43 112.605C168.441 113.109 144.756 112.088 144.756 112.088L143.824 118.186C143.824 118.186 170.288 122.633 175.091 120.175C179.894 117.717 195.344 93.8719 186.538 90.7013Z"
            fill="#AAAAAA"
          />
          <path
            opacity="0.3"
            d="M167.277 90.2025C163.893 92.5419 162.705 101.888 162.705 101.888C162.112 105.806 162.236 107.012 164.724 107.498C170.935 108.923 173.749 105.83 174.283 102.689C174.283 102.689 176.183 92.3638 179.206 89.9413L170.721 93.7413L167.277 90.2025Z"
            fill="white"
          />
          <path
            d="M167.277 90.2025C163.893 92.5419 162.705 101.888 162.705 101.888C162.112 105.806 162.236 107.012 164.724 107.498C170.935 108.923 173.749 105.83 174.283 102.689C174.283 102.689 176.183 92.3638 179.206 89.9413L170.721 93.7413L167.277 90.2025Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.5"
            d="M167.277 90.2025C163.893 92.5419 162.705 101.888 162.705 101.888C162.112 105.806 162.236 107.012 164.724 107.498C170.935 108.923 173.749 105.83 174.283 102.689C174.283 102.689 176.183 92.3638 179.206 89.9413L170.721 93.7413L167.277 90.2025Z"
            fill="white"
          />
          <path
            d="M170.721 93.7413L172.235 89.5316L178.748 87.2575L179.2 89.9413L170.721 93.7413Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.05"
            d="M170.721 93.7413L172.235 89.5316L178.748 87.2575L179.2 89.9413L170.721 93.7413Z"
            fill="white"
          />
          <path
            d="M172.235 89.5316L174.058 93.7413L179.2 89.9413L178.748 87.2575L172.235 89.5316Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.2"
            d="M172.235 89.5316L174.058 93.7413L179.2 89.9413L178.748 87.2575L172.235 89.5316Z"
            fill="white"
          />
          <path
            d="M170.721 93.7413L168.975 89.5198L169.385 87.7266L167.277 90.2026L170.721 93.7413Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.05"
            d="M170.721 93.7413L168.975 89.5198L169.385 87.7266L167.277 90.2026L170.721 93.7413Z"
            fill="white"
          />
          <path
            d="M168.975 89.5198L167.141 94.1391L167.277 90.2026L169.385 87.7266L168.975 89.5198Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.2"
            d="M168.975 89.5198L167.141 94.1391L167.277 90.2026L169.385 87.7266L168.975 89.5198Z"
            fill="white"
          />
          <path
            d="M62.603 94.9914L61.2966 95.271L63.6054 106.059L64.9117 105.779L62.603 94.9914Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.3"
            d="M62.603 94.9914L61.2966 95.271L63.6054 106.059L64.9117 105.779L62.603 94.9914Z"
            fill="white"
          />
          <path
            d="M67.0463 93.9371H65.7103V104.969H67.0463V93.9371Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.3"
            d="M67.0463 93.9371H65.7103V104.969H67.0463V93.9371Z"
            fill="white"
          />
          <path
            d="M73.1238 96.48L71.8524 96.0698L68.4654 106.569L69.7368 106.979L73.1238 96.48Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.3"
            d="M73.1238 96.48L71.8524 96.0698L68.4654 106.569L69.7368 106.979L73.1238 96.48Z"
            fill="white"
          />
          <path
            d="M62.3438 104.975H71.7131V117.521C71.7131 117.768 71.6644 118.013 71.5699 118.241C71.4753 118.469 71.3366 118.677 71.1618 118.852C70.9871 119.027 70.7796 119.165 70.5512 119.26C70.3229 119.354 70.0781 119.403 69.8309 119.403H64.2437C63.7446 119.403 63.2658 119.205 62.9128 118.852C62.5599 118.499 62.3616 118.02 62.3616 117.521V104.975H62.3438Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.1"
            d="M62.3438 104.975H71.7131V117.521C71.7131 117.768 71.6644 118.013 71.5699 118.241C71.4753 118.469 71.3366 118.677 71.1618 118.852C70.9871 119.027 70.7796 119.165 70.5512 119.26C70.3229 119.354 70.0781 119.403 69.8309 119.403H64.2437C63.7446 119.403 63.2658 119.205 62.9128 118.852C62.5599 118.499 62.3616 118.02 62.3616 117.521V104.975H62.3438Z"
            fill="white"
          />
          <path
            d="M194.073 182.661L193.141 184.401V186.093L195.142 186.806L197.814 186.538L197.238 184.49L194.073 182.661Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.3"
            d="M194.073 182.661L193.141 184.401V186.093L195.142 186.806L197.814 186.538L197.238 184.49L194.073 182.661Z"
            fill="white"
          />
          <path
            opacity="0.3"
            d="M193.628 184.264L194.964 184.733V186.271L194.608 185.268L193.984 185.511L194.299 184.977L193.628 184.264Z"
            fill="#323232"
          />
          <path
            opacity="0.3"
            d="M195.943 184.733H196.917L197.547 186.271L196.745 185.268L195.943 184.733Z"
            fill="#323232"
          />
          <path
            d="M190.76 188.07L188.753 186.58L190 184.377L192.672 183.754L194.186 184.953L193.919 188.07H190.76Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.2"
            d="M190.76 188.07L188.753 186.58L190 184.377L192.672 183.754L194.186 184.953L193.919 188.07H190.76Z"
            fill="white"
          />
          <path
            opacity="0.3"
            d="M189.157 186.473L190.891 185.915L192.583 186.473L193.652 187.851L192.007 186.806L190.849 187.138V186.289L189.157 186.473Z"
            fill="#323232"
          />
          <path
            opacity="0.3"
            d="M190.534 184.733L191.473 185.446H192.452L193.384 185.09H191.959L190.534 184.733Z"
            fill="#323232"
          />
          <path
            d="M198.77 183.32L197.297 185.41L198.77 187.684L200.058 187.37L201.798 187.417L202.51 185.499L199.904 183.32H198.77Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.2"
            d="M198.77 183.32L197.297 185.41L198.77 187.684L200.058 187.37L201.798 187.417L202.51 185.499L199.904 183.32H198.77Z"
            fill="white"
          />
          <path
            opacity="0.3"
            d="M197.79 185.22H199.346L198.948 187.192L198.859 185.725L197.79 185.22Z"
            fill="#323232"
          />
          <path
            opacity="0.3"
            d="M199.761 186.972L199.904 185.22L202.017 185.725L200.889 185.992L201.394 186.972L200.325 185.725L199.761 186.972Z"
            fill="#323232"
          />
          <path
            opacity="0.3"
            d="M198.568 184.454L199.346 183.985L200.325 184.454L201.353 185.22L199.346 184.454H198.568Z"
            fill="#323232"
          />
          <path
            d="M199.957 184.11L201.121 187.625L203.164 188.07L206.014 187.494L207.439 185.582L206.103 182.685L201.964 182.37L199.957 184.11Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.1"
            d="M199.957 184.11L201.121 187.625L203.164 188.07L206.014 187.494L207.439 185.582L206.103 182.685L201.964 182.37L199.957 184.11Z"
            fill="white"
          />
          <path
            opacity="0.3"
            d="M201.465 186.889L202.706 185.482L204.41 185.553L204.642 186.972L204.108 186.052L202.896 185.933L201.465 186.889Z"
            fill="#323232"
          />
          <path
            opacity="0.3"
            d="M204.903 185.398L206.459 185.149L207.159 185.482L206.031 187.186L206.762 185.654L206.346 185.482L204.903 185.398Z"
            fill="#323232"
          />
          <path
            opacity="0.3"
            d="M201.382 186.052L200.313 184.235L201.786 183.314L204.642 184.015L202.095 183.748L200.901 184.448L201.382 186.052Z"
            fill="#323232"
          />
          <path
            opacity="0.3"
            d="M203.057 182.744L205.681 182.982L206.726 184.686L205.491 183.314L203.057 182.744Z"
            fill="#323232"
          />
          <path
            d="M187.839 187.506H208.353V211.642C208.353 212.378 208.061 213.083 207.541 213.603C207.021 214.123 206.315 214.415 205.58 214.415H190.594C189.858 214.415 189.153 214.123 188.633 213.603C188.113 213.083 187.821 212.378 187.821 211.642V187.506H187.839Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.3"
            d="M187.839 187.506H208.353V211.642C208.353 212.378 208.061 213.083 207.541 213.603C207.021 214.123 206.315 214.415 205.58 214.415H190.594C189.858 214.415 189.153 214.123 188.633 213.603C188.113 213.083 187.821 212.378 187.821 211.642V187.506H187.839Z"
            fill="white"
          />
          <path
            d="M188.296 186.224H207.89C208.09 186.224 208.281 186.303 208.423 186.445C208.564 186.586 208.644 186.778 208.644 186.978V187.791H187.542V186.978C187.542 186.778 187.621 186.586 187.763 186.445C187.904 186.303 188.096 186.224 188.296 186.224Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.4"
            d="M188.296 186.224H207.89C208.09 186.224 208.281 186.303 208.423 186.445C208.564 186.586 208.644 186.778 208.644 186.978V187.791H187.542V186.978C187.542 186.778 187.621 186.586 187.763 186.445C187.904 186.303 188.096 186.224 188.296 186.224Z"
            fill="white"
          />
          <path
            d="M91.295 134.372H83.9028V214.486H91.295V134.372Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.4"
            d="M91.301 134.33H87.4653V214.445H91.301V134.33Z"
            fill="#C8C8C8"
          />
          <path
            d="M215.104 134.33H211.268V214.445H215.104V134.33Z"
            fill="#D0D0D0"
          />
          <path
            d="M47.785 134.33H43.9493V214.445H47.785V134.33Z"
            fill="#D0D0D0"
          />
          <path
            d="M219.04 214.421H215.205V134.348H154.108V214.421H147.096V134.348H44.2047V214.421H40.6897V119.403H219.04V214.421Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.1"
            d="M219.04 214.421H215.205V134.348H154.108V214.421H150.314V124.064H219.04V214.421Z"
            fill="white"
          />
          <path
            opacity="0.3"
            d="M219.04 119.403H150.314V124.064H219.04V119.403Z"
            fill="#C8C8C8"
          />
          <path
            opacity="0.1"
            d="M150.355 119.403H40.6897V124.064H150.355V119.403Z"
            fill="#C8C8C8"
          />
          <path
            opacity="0.4"
            d="M150.361 214.421L146.989 214.338L147.096 134.348H44.2047V214.421H40.6897V124.064H150.361V214.421Z"
            fill="white"
          />
          <path
            opacity="0.4"
            d="M47.785 134.33H43.9493V214.445H47.785V134.33Z"
            fill="#C8C8C8"
          />
          <path
            opacity="0.4"
            d="M215.104 134.33H211.268V214.445H215.104V134.33Z"
            fill="#C8C8C8"
          />
          <path
            d="M100.035 117.028V118.596C100.035 119.071 100.848 119.403 101.312 119.403H138.005C138.474 119.403 139.223 119.071 139.223 118.596V117.028H100.035Z"
            fill="#323232"
          />
          <path
            opacity="0.6"
            d="M100.035 117.028V118.596C100.035 119.071 100.848 119.403 101.312 119.403H138.005C138.474 119.403 139.223 119.071 139.223 118.596V117.028H100.035Z"
            fill="white"
          />
          <path
            opacity="0.2"
            d="M100.035 117.028V118.596C100.035 119.071 100.848 119.403 101.312 119.403H125.513C125.982 119.403 126.754 119.071 126.754 118.596V117.028H100.035Z"
            fill="#C8C8C8"
          />
          <path
            d="M94.1569 97.7372L98.5209 117.616C98.5983 117.94 98.7782 118.231 99.0338 118.445C99.2894 118.659 99.6072 118.784 99.94 118.803H123.797C123.95 118.79 124.098 118.742 124.23 118.664C124.363 118.586 124.476 118.479 124.562 118.352C124.648 118.224 124.704 118.079 124.727 117.928C124.75 117.776 124.738 117.62 124.693 117.473L120.335 97.8084C120.246 97.5079 120.057 97.2472 119.798 97.0699C119.54 96.8926 119.229 96.8095 118.916 96.8347H95.0534C94.4063 96.8406 94.0144 97.09 94.1569 97.7372Z"
            fill="#323232"
          />
          <path
            opacity="0.6"
            d="M94.1569 97.7372L98.5209 117.616C98.5983 117.94 98.7782 118.231 99.0338 118.445C99.2894 118.659 99.6072 118.784 99.94 118.803H123.797C123.95 118.79 124.098 118.742 124.23 118.664C124.363 118.586 124.476 118.479 124.562 118.352C124.648 118.224 124.704 118.079 124.727 117.928C124.75 117.776 124.738 117.62 124.693 117.473L120.335 97.8084C120.246 97.5079 120.057 97.2472 119.798 97.0699C119.54 96.8926 119.229 96.8095 118.916 96.8347H95.0534C94.4063 96.8406 94.0144 97.09 94.1569 97.7372Z"
            fill="white"
          />
          <path
            opacity="0.4"
            d="M94.1569 97.7372L98.5209 117.616C98.5983 117.94 98.7782 118.231 99.0338 118.445C99.2894 118.659 99.6072 118.784 99.94 118.803H122.989C123.143 118.79 123.291 118.742 123.423 118.664C123.556 118.586 123.669 118.479 123.755 118.352C123.842 118.225 123.899 118.08 123.922 117.928C123.946 117.776 123.936 117.621 123.892 117.473L119.522 97.8084C119.433 97.5079 119.243 97.2472 118.985 97.0699C118.727 96.8926 118.415 96.8095 118.103 96.8347H95.0534C94.4063 96.8406 94.0144 97.09 94.1569 97.7372Z"
            fill="white"
          />
          <path
            opacity="0.2"
            d="M108.187 110.479C107.077 110.479 105.937 109.292 105.646 107.819C105.355 106.347 106.026 105.153 107.142 105.153C107.346 105.157 107.547 105.198 107.736 105.272C107.839 105.797 108.064 106.29 108.393 106.712C108.722 107.134 109.146 107.473 109.63 107.7C109.633 107.74 109.633 107.78 109.63 107.819C109.974 109.286 109.303 110.479 108.187 110.479Z"
            fill="#C8C8C8"
          />
          <path
            d="M199.209 83.0003L212.438 86.0462C212.624 90.942 214.671 95.5823 218.161 99.0204C221.651 102.459 226.322 104.436 231.22 104.548C236.118 104.66 240.874 102.9 244.519 99.6253C248.163 96.3508 250.421 91.8093 250.831 86.9272C251.242 82.0452 249.774 77.1904 246.728 73.3534C243.681 69.5165 239.286 66.9864 234.437 66.2794C229.589 65.5724 224.654 66.7417 220.639 69.5488C216.624 72.3559 213.831 76.5893 212.83 81.3853L199.209 83.0003Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.7"
            d="M199.209 83.0003L212.438 86.0462C212.624 90.942 214.671 95.5823 218.161 99.0204C221.651 102.459 226.322 104.436 231.22 104.548C236.118 104.66 240.874 102.9 244.519 99.6253C248.163 96.3508 250.421 91.8093 250.831 86.9272C251.242 82.0452 249.774 77.1904 246.728 73.3534C243.681 69.5165 239.286 66.9864 234.437 66.2794C229.589 65.5724 224.654 66.7417 220.639 69.5488C216.624 72.3559 213.831 76.5893 212.83 81.3853L199.209 83.0003Z"
            fill="white"
          />
          <path
            d="M243.693 72.4375C242.237 72.4366 240.795 72.7189 239.447 73.2687C238.821 70.9599 237.377 68.9573 235.384 67.6334C233.392 66.3096 230.986 65.7547 228.615 66.0719C226.244 66.3892 224.069 67.557 222.494 69.3582C220.92 71.1593 220.053 73.4711 220.056 75.8634C220.056 76.0653 220.056 76.2672 220.085 76.4572H220.056C217.738 76.4899 215.518 77.39 213.832 78.9799C212.146 80.5698 211.117 82.734 210.948 85.0452C210.78 87.3565 211.484 89.647 212.921 91.4646C214.359 93.2822 216.426 94.4949 218.714 94.8634V95H243.693C246.685 95 249.554 93.8114 251.67 91.6958C253.785 89.5801 254.974 86.7107 254.974 83.7187C254.974 80.7267 253.785 77.8573 251.67 75.7417C249.554 73.626 246.685 72.4375 243.693 72.4375Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.9"
            d="M243.693 72.4375C242.237 72.4366 240.795 72.7189 239.447 73.2687C238.821 70.9599 237.377 68.9573 235.384 67.6334C233.392 66.3096 230.986 65.7547 228.615 66.0719C226.244 66.3892 224.069 67.557 222.494 69.3582C220.92 71.1593 220.053 73.4711 220.056 75.8634C220.056 76.0653 220.056 76.2672 220.085 76.4572H220.056C217.738 76.4899 215.518 77.39 213.832 78.9799C212.146 80.5698 211.117 82.734 210.948 85.0452C210.78 87.3565 211.484 89.647 212.921 91.4646C214.359 93.2822 216.426 94.4949 218.714 94.8634V95H243.693C246.685 95 249.554 93.8114 251.67 91.6958C253.785 89.5801 254.974 86.7107 254.974 83.7187C254.974 80.7267 253.785 77.8573 251.67 75.7417C249.554 73.626 246.685 72.4375 243.693 72.4375Z"
            fill="white"
          />
          <path
            d="M237.607 99.1147V89.5553H227.27V99.1147H223.95L232.144 106.335L240.338 99.1147H237.607Z"
            fill="#D0D0D0"
          />
          <path
            d="M182.103 56.8575L191.746 46.6866C196.194 49.0815 201.388 49.6892 206.268 48.3857C211.149 47.0823 215.349 43.9659 218.01 39.6723C220.672 35.3787 221.595 30.2313 220.592 25.2802C219.589 20.3291 216.734 15.9474 212.611 13.0288C208.487 10.1102 203.406 8.87463 198.403 9.57418C193.4 10.2737 188.852 12.8557 185.688 16.7933C182.523 20.7309 180.98 25.7276 181.373 30.764C181.766 35.8004 184.066 40.4971 187.803 43.896L182.103 56.8575Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.7"
            d="M182.103 56.8575L191.746 46.6866C196.194 49.0815 201.388 49.6892 206.268 48.3857C211.149 47.0823 215.349 43.9659 218.01 39.6723C220.672 35.3787 221.595 30.2313 220.592 25.2802C219.589 20.3291 216.734 15.9474 212.611 13.0288C208.487 10.1102 203.406 8.87463 198.403 9.57418C193.4 10.2737 188.852 12.8557 185.688 16.7933C182.523 20.7309 180.98 25.7276 181.373 30.764C181.766 35.8004 184.066 40.4971 187.803 43.896L182.103 56.8575Z"
            fill="white"
          />
          <path
            d="M184.561 16.0135L202.724 1.43097L221.392 16.0135L204.701 32.5197L184.561 16.0135Z"
            fill="#D0D0D0"
          />
          <path
            d="M219.729 8.1344H185.826V28.1675H219.729V8.1344Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.5"
            d="M219.729 8.1344H185.826V28.1675H219.729V8.1344Z"
            fill="white"
          />
          <path
            d="M218.019 12.736H191.389V13.3772H218.019V12.736Z"
            fill="white"
          />
          <path
            d="M218.013 14.6597H187.429V15.4079H218.013V14.6597Z"
            fill="white"
          />
          <path
            d="M218.013 16.6904H187.429V17.4385H218.013V16.6904Z"
            fill="white"
          />
          <path
            d="M218.013 18.6141H187.429V19.3622H218.013V18.6141Z"
            fill="white"
          />
          <path
            d="M218.013 20.6151H187.429V21.3632H218.013V20.6151Z"
            fill="white"
          />
          <path
            d="M218.067 22.3607H187.483V23.1088H218.067V22.3607Z"
            fill="white"
          />
          <path
            d="M218.067 24.2844H187.483V25.0326H218.067V24.2844Z"
            fill="white"
          />
          <path
            d="M218.013 25.7806H187.429V26.5288H218.013V25.7806Z"
            fill="white"
          />
          <path
            d="M221.392 37.6141H184.561V16.0135L202.973 28.2032L221.392 16.0135V37.6141Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.2"
            d="M221.392 37.6141H184.561V16.0135L202.973 28.2032L221.392 16.0135V37.6141Z"
            fill="white"
          />
          <path
            d="M148.776 59.9984L143.432 45.505C147.967 42.2862 151.103 37.4587 152.201 32.0071C153.298 26.5555 152.275 20.8905 149.339 16.1676C146.403 11.4448 141.776 8.01987 136.401 6.59146C131.027 5.16305 125.31 5.83876 120.417 8.48077C115.523 11.1228 111.822 15.5321 110.068 20.8092C108.315 26.0864 108.64 31.8339 110.978 36.8794C113.317 41.9249 117.492 45.8883 122.652 47.9611C127.812 50.034 133.569 50.0602 138.748 48.0344L148.776 59.9984Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.7"
            d="M148.776 59.9984L143.432 45.505C147.967 42.2862 151.103 37.4587 152.201 32.0071C153.298 26.5555 152.275 20.8905 149.339 16.1676C146.403 11.4448 141.776 8.01987 136.401 6.59146C131.027 5.16305 125.31 5.83876 120.417 8.48077C115.523 11.1228 111.822 15.5321 110.068 20.8092C108.315 26.0864 108.64 31.8339 110.978 36.8794C113.317 41.9249 117.492 45.8883 122.652 47.9611C127.812 50.034 133.569 50.0602 138.748 48.0344L148.776 59.9984Z"
            fill="white"
          />
          <path
            d="M146.549 5.99683H116.844V44.3412H146.549V5.99683Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.4"
            d="M146.549 8.03937H116.844V44.3412H146.549V8.03937Z"
            fill="white"
          />
          <path
            opacity="0.7"
            d="M132.151 10.4678H121.463C121.274 10.467 121.087 10.5036 120.912 10.5755C120.737 10.6473 120.578 10.753 120.444 10.8865C120.31 11.02 120.203 11.1787 120.131 11.3534C120.058 11.5281 120.021 11.7155 120.021 11.9047V14.0244C120.021 14.407 120.173 14.774 120.443 15.0446C120.714 15.3152 121.081 15.4672 121.463 15.4672H121.843C121.71 15.8714 121.471 16.2324 121.15 16.5123C120.829 16.7923 120.439 16.9809 120.021 17.0584C121.392 16.999 122.289 16.4647 122.722 15.4672H132.145C132.335 15.4679 132.523 15.4312 132.699 15.359C132.875 15.2869 133.034 15.1807 133.169 15.0467C133.304 14.9126 133.41 14.7533 133.483 14.5779C133.556 14.4024 133.594 14.2143 133.594 14.0244V11.9047C133.594 11.7155 133.556 11.5281 133.484 11.3534C133.411 11.1787 133.305 11.02 133.171 10.8865C133.037 10.753 132.878 10.6473 132.703 10.5755C132.528 10.5036 132.34 10.467 132.151 10.4678Z"
            fill="white"
          />
          <path
            opacity="0.7"
            d="M132.406 23.9518H121.238C120.923 23.9518 120.621 24.077 120.398 24.2997C120.175 24.5224 120.05 24.8244 120.05 25.1393V26.1962C120.05 26.5112 120.175 26.8132 120.398 27.0359C120.621 27.2586 120.923 27.3837 121.238 27.3837H121.879C121.761 27.8128 121.525 28.2001 121.197 28.5013C120.87 28.8026 120.464 29.0058 120.027 29.0878C121.446 29.0225 122.354 28.4525 122.77 27.3837H132.406C132.724 27.3838 133.029 27.2597 133.257 27.0378C133.484 26.8159 133.616 26.5139 133.623 26.1962V25.169C133.623 24.8462 133.495 24.5366 133.267 24.3084C133.039 24.0801 132.729 23.9518 132.406 23.9518Z"
            fill="white"
          />
          <path
            opacity="0.7"
            d="M142.138 30.2456H135.773C135.446 30.2456 135.133 30.3749 134.902 30.6052C134.67 30.8355 134.539 31.1482 134.538 31.4747V32.0684C134.539 32.3949 134.67 32.7075 134.902 32.9379C135.133 33.1682 135.446 33.2975 135.773 33.2975H140.244C140.659 34.3662 141.568 34.9422 142.987 35.0075C142.55 34.924 142.145 34.7195 141.819 34.4172C141.492 34.1148 141.257 33.7269 141.14 33.2975H142.138C142.464 33.2975 142.776 33.168 143.007 32.9375C143.237 32.707 143.367 32.3944 143.367 32.0684V31.4747C143.367 31.1487 143.237 30.8361 143.007 30.6056C142.776 30.3751 142.464 30.2456 142.138 30.2456Z"
            fill="white"
          />
          <path
            opacity="0.7"
            d="M142.156 16.3756H126.926C126.608 16.3755 126.303 16.4997 126.076 16.7216C125.848 16.9434 125.716 17.2455 125.709 17.5631V20.3715C125.716 20.6892 125.848 20.9912 126.076 21.2131C126.303 21.435 126.608 21.5591 126.926 21.559H140.202C140.594 22.699 141.52 23.3403 142.987 23.3759C142.532 23.2885 142.112 23.0699 141.78 22.7471C141.448 22.4243 141.217 22.0113 141.117 21.559H142.156C142.471 21.559 142.773 21.4339 142.995 21.2112C143.218 20.9885 143.343 20.6865 143.343 20.3715V17.5869C143.346 17.4289 143.318 17.272 143.26 17.1251C143.201 16.9783 143.114 16.8446 143.004 16.7318C142.893 16.619 142.761 16.5294 142.616 16.4682C142.47 16.4071 142.314 16.3756 142.156 16.3756Z"
            fill="white"
          />
          <path
            opacity="0.8"
            d="M143.408 39.615H119.985C119.395 39.615 118.916 40.0935 118.916 40.6837V41.1706C118.916 41.7609 119.395 42.2394 119.985 42.2394H143.408C143.999 42.2394 144.477 41.7609 144.477 41.1706V40.6837C144.477 40.0935 143.999 39.615 143.408 39.615Z"
            fill="white"
          />
          <path
            d="M121.214 78.2266L107.332 72.8472C107.89 67.518 106.393 62.1767 103.148 57.913C99.9024 53.6492 95.1527 50.7841 89.8674 49.9022C84.5821 49.0202 79.1594 50.1878 74.7054 53.1667C70.2514 56.1457 67.1017 60.7116 65.8986 65.9332C64.6955 71.1548 65.5298 76.6386 68.2312 81.2662C70.9326 85.8938 75.2977 89.3165 80.436 90.8362C85.5744 92.3559 91.0989 91.858 95.8829 89.4443C100.667 87.0305 104.35 82.8826 106.18 77.8466L121.214 78.2266Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.7"
            d="M121.214 78.2266L107.332 72.8472C107.89 67.518 106.393 62.1767 103.148 57.913C99.9024 53.6492 95.1527 50.7841 89.8674 49.9022C84.5821 49.0202 79.1594 50.1878 74.7054 53.1667C70.2514 56.1457 67.1017 60.7116 65.8986 65.9332C64.6955 71.1548 65.5298 76.6386 68.2312 81.2662C70.9326 85.8938 75.2977 89.3165 80.436 90.8362C85.5744 92.3559 91.0989 91.858 95.8829 89.4443C100.667 87.0305 104.35 82.8826 106.18 77.8466L121.214 78.2266Z"
            fill="white"
          />
          <path
            d="M107.16 76.3326H65.1997V77.247H107.16V76.3326Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.3"
            d="M107.16 76.3326H65.1997V77.247H107.16V76.3326Z"
            fill="#C8C8C8"
          />
          <path
            d="M75.6022 68.4891H70.8582V76.3326H75.6022V68.4891Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.4"
            d="M75.6022 68.4891H70.8582V76.3326H75.6022V68.4891Z"
            fill="white"
          />
          <path
            d="M83.9919 64.1132H79.2478V76.3385H83.9919V64.1132Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.4"
            d="M83.9919 64.1132H79.2478V76.3385H83.9919V64.1132Z"
            fill="white"
          />
          <path
            d="M92.7497 59.7372H88.0056V76.3385H92.7497V59.7372Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.4"
            d="M92.7497 59.7372H88.0056V76.3385H92.7497V59.7372Z"
            fill="white"
          />
          <path
            d="M101.507 55.5394H96.7634V76.3385H101.507V55.5394Z"
            fill="#D0D0D0"
          />
          <path
            opacity="0.2"
            d="M101.507 55.5394H96.7634V76.3385H101.507V55.5394Z"
            fill="#323232"
          />
        </g>
        <defs>
          <clipPath id="clip0_3185_48915">
            <rect width="266" height="229.781" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
});
